import Resource from "./Resource";

export default class ThermostatResource extends Resource {
  remove(projectId: number, roomId: number, thermostatId: number) {
    return this.http.delete(`projects/${projectId}/rooms/${roomId}/thermostats/${thermostatId}`);
  }
}
